// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	BUTTON_YES: '[data-fragment="IntroPage.buttonYes"]',
	BUTTON_NO: '[data-fragment="IntroPage.buttonNo"]',
}

export default class IntroPage extends WebComponent {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
		};
	}

	didMount() {
		const {
			cookieName,
		} = this.props;

		this.cookieName = cookieName;

		this.buttonYes = this.element.querySelector(fragments.BUTTON_YES);
		this.on('click', fragments.BUTTON_YES, this.handleClickButtonYes);
		this.on('click', fragments.BUTTON_NO, this.handleClickButtonNo);
		let cookieValue = this.getCookie(this.cookieName);
		if (cookieValue === "" || cookieValue == null) {
			if(!document.body.classList.contains('cookiesPolicy__page')) {
				this.showIntroPage();
			}
		}
		if (cookieValue === '1') {
			this.addLimitationsClass();
		}
	}

	handleClickButtonYes = (e) => {
		e.preventDefault();
		this.hideIntroPage();
		this.setCookie(this.cookieName, 0, 7);
	}

	handleClickButtonNo = (e) => {
		e.preventDefault();
		this.hideIntroPage();
		this.addLimitationsClass();
		this.setCookie(this.cookieName, 1, null);
	}

	addLimitationsClass = () => {
		document.body.classList.add('intro-page--limitations');
	}

	showIntroPage = () => {
		document.body.classList.add('intro-page--show');
	}

	hideIntroPage = () => {
		document.body.classList.remove('intro-page--show');
	}

	setCookie(cName, cValue, cDate) {
		if(cDate != null) {
			let d = new Date();
			d.setTime(d.getTime() + (cDate*24*60*60*1000));
			let expires = "expires="+ d.toUTCString();
			document.cookie = cName + "=" + cValue + ";" + expires + ";path=/";
		} else {
			document.cookie = cName + "=" + cValue + ";path=/";
		}
	}

	getCookie(cName) {
		var name = cName + "=";
		var ca = document.cookie.split(';');
		for(var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

}

IntroPage.defaultProps = {
	cookieName: 'rpbAgeCheck'
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/IntroPage.js